import {Injectable, Inject} from 'ng-metadata/core';
import {getInjectableName} from 'ng-metadata/core';
import {HttpService} from '../../infra/httpRequest/http.service';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import appConfigModule from '../../appConfig/appConfig.module';
import {getVid} from '../../appConfig/appConfigForward';
@Injectable()
export class AlmaViewerService {
	private vid: string= getVid();
private _repPid: string=this.getRepId();
private _mmsId: string=this.getMmsId();
private _pid: string=this.getPid();
private _inst: string=this.getInst();
private _requestId: string="";
private _sourceType: string="";
private _mmsRes:String="";
private $http: ng.IHttpService;
private primaBaseUrl:any;
	    //Default Paths. will be updated in constructor;
        private ilsServices:object={};

	constructor(@Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$translate') private $translate,
                @Inject('restBaseURLs') private restBaseURLs,
                private httpService: HttpService,
                private configurationUtil : ConfigurationUtil){
                        this.primaBaseUrl = restBaseURLs.deliveryBaseURL;

           this.ilsServices = {
        'representationInfo': {
            'path': this.primaBaseUrl,        
            'method': 'GET'
        } };     
	}
	
	private resquestInProgress:Object = {};
	    


    public getServices(){
        return this.ilsServices;
    }

    makeIlsRequest(serviceName: string, params: Object){
        if(!params){
            params= {};
        }
        let serviceDetails = this.ilsServices[serviceName];
        this.resquestInProgress[serviceName] = true;

        return this.httpService.call(serviceDetails.method, serviceDetails.path, params)
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response);
                },
                (error)=>{
                    return this.ilsRequestFailure(error, serviceName, params);
                }
            ).finally( () =>
                this.resquestInProgress[serviceName] = false
            );
    }

    public getDisplayBackToSearchLink(){
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            if(this.configurationUtil.getSummonOverAlma() === true){
                return false;
            }
        }
        return true;
    }

    get requestInProgress(){
        return this.resquestInProgress || false;
    }

    private ilsRequestSuccess(response){
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }
	private getRepId() {
        return  this.$state.params['repId']; 
        
    } 
    private getPid() {
    	return  this.$state.params['pid'];
    } 
    private getMmsId() {
    	return  this.$state.params['mmsId'];
    } 
    private getInst() {
    	return  this.vid.split(':')[0];
    } 
    	private getRequestId() {
    	return this._requestId;
    	}
        public    setRequestId(reqId){
    this._requestId=reqId;
    }

    private getSourceType() {
    	return this._sourceType;
    	}
        public    setSourceType(srcType){
    this._sourceType=srcType;
    }
        	private getMmsRes() {
    	return this._mmsRes;
    	}
        public    setmmsRes(mmsId){
    this._mmsRes=mmsId;
    }
  
    public getRepresentationInfo(params){		
    if (!params){

    params = {
			repId: this._repPid,
            mmsId:this._mmsRes,
            pid:this._pid,
			inst: this._inst
		};
		}
        return this.makeIlsRequest('representationInfo', params);
   }
}          
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/delivery/almaViewer/almaViewer.service.ts